import { type OurIntlShape } from '@/i18n/typing'
import { type PostType, postTypeSchema } from '@/types/schema/post-type'
import { PlatformShortcode } from '@/utils/convert-platform'

const getPostTypeLabel = (
  type: PostType,
  platform: PlatformShortcode | '',
  formatMessage: OurIntlShape['formatMessage'],
): string => {
  if (type === postTypeSchema.enum.image) {
    return formatMessage({ id: 'kol:content_option_image_text' })
  }

  if (platform === PlatformShortcode.All) {
    if (
      type === postTypeSchema.enum.video ||
      type === postTypeSchema.enum.live ||
      type === postTypeSchema.enum.short
    ) {
      return formatMessage({ id: 'kol:graph_illu_all_videos' })
    }
  }

  if (platform === PlatformShortcode.Facebook) {
    if (type === postTypeSchema.enum.video) {
      return formatMessage({ id: 'kol:post_type_other_video' })
    }
  }

  if (platform === PlatformShortcode.Instagram) {
    if (type === postTypeSchema.enum.short) {
      return 'Reels'
    }

    if (type === postTypeSchema.enum.video) {
      return formatMessage({ id: 'kol:post_type_other_video' })
    }
  }

  if (platform === PlatformShortcode.YouTube) {
    if (type === postTypeSchema.enum.short) {
      return 'Shorts'
    }

    if (type === postTypeSchema.enum.video) {
      return formatMessage({ id: 'kol:post_type_other_video' })
    }
  }

  if (
    platform === PlatformShortcode.TikTok ||
    platform === PlatformShortcode.Twitter
  ) {
    if (type === postTypeSchema.enum.video) {
      return formatMessage({ id: 'kol:post_lable_video' })
    }
  }

  return ''
}

export default getPostTypeLabel
